import React from "react";
import { Pressable, StyleProp, StyleSheet, ViewStyle } from "react-native";
import { kStyleConst } from "src/kStyle";
import { Radio_Button } from "../impComponents";
import { PdText } from "../layout";

export type tPdRadioOption = {
  value: string;
  label: string;
};

export type tPdRadioGroup = {
  value?: string;
  onChange?: (option: string) => void;
  isDisabled?: boolean;
};

export type tPdRadio = {
  value: string;
  style?: StyleProp<ViewStyle>;
};

interface iPdRadioGroupContext {
  currentValue: string;
  onChange: (option: string) => void;
  isDisabled: boolean;
}

const RadioGroupContext = React.createContext<Partial<iPdRadioGroupContext>>({});

export const PdRadioGroup: React.FC<tPdRadioGroup> = (props) => {
  const { value, onChange, isDisabled, children } = props;

  return (
    <RadioGroupContext.Provider value={{ currentValue: value, onChange, isDisabled }}>
      {children}
    </RadioGroupContext.Provider>
  );
};

export const PdRadio: React.FC<tPdRadio> = ({ value, style, children }) => {
  const { currentValue, onChange, isDisabled } = React.useContext(RadioGroupContext);

  const handleOnPress = () => {
    if (isDisabled) return;
    onChange?.(value);
  };

  return (
    <Pressable onPress={handleOnPress} style={[styles.alignCenter, styles.flexRow, style]}>
      <Radio_Button style={{ height: kStyleConst.kRadioButton }} state={currentValue === value ? "on" : "off"} />
      <PdText style={styles.pdRadioLabel}>{children}</PdText>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  flexRow: {
    flexDirection: "row",
  },
  pdRadioLabel: {
    fontSize: 11,
    marginLeft: 8,
    textTransform: "uppercase",
  },
});
